// Numbered MUI Pagination for @mui/x-data-grid (v5), so DataGrid tables use the
// exact same pager style as manual tables. Wired as the default DataGrid
// Pagination component via the theme (see theme/components.js).

import React from "react";
import Box from "@mui/material/Box";
import Pagination from "@mui/material/Pagination";
import {
  useGridApiContext,
  useGridSelector,
  gridPageCountSelector,
  gridPageSelector,
} from "@mui/x-data-grid";

const DataGridPagination = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  if (!pageCount || pageCount <= 1) return null;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%", py: 1 }}>
      <Pagination
        count={pageCount}
        page={page + 1}
        onChange={(event, value) => apiRef.current.setPage(value - 1)}
      />
    </Box>
  );
};

export default DataGridPagination;
